import { Link } from "react-router-dom";
import { Radar } from "lucide-react";

const WA = process.env.REACT_APP_WHATSAPP_COMMUNITY || "#";
const IG = process.env.REACT_APP_INSTAGRAM || "#";

export function SocialButtons({ compact = false }) {
  const base = compact ? "h-8 px-3 text-xs" : "h-10 px-4 text-sm";
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <a
        href={WA}
        target="_blank"
        rel="noreferrer"
        className={`${base} inline-flex items-center gap-2 rounded-lg bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold transition-colors`}
        data-testid="social-whatsapp-btn"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.6-.8-1.9-.9-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.2-1.3-.8-.7-1.4-1.6-1.5-1.9-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5 0-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5H8.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3 4.8 4.2.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.6-.7 1.9-1.3.2-.6.2-1.2.2-1.3-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.7.4 3.4 1.3 4.9L2 22l5.3-1.4C8.8 21.5 10.4 22 12 22c5.5 0 10-4.5 10-10S17.5 2 12 2z"/></svg>
        {compact ? "Comunidade" : "Comunidade WhatsApp"}
      </a>
      <a
        href={IG}
        target="_blank"
        rel="noreferrer"
        className={`${base} inline-flex items-center gap-2 rounded-lg bg-gradient-to-tr from-fuchsia-500 via-rose-500 to-amber-500 hover:brightness-110 text-white font-semibold transition-all`}
        data-testid="social-instagram-btn"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 2c2.7 0 3.1 0 4.1.1 1.1.1 1.8.2 2.4.5.7.3 1.3.6 1.8 1.2.6.5.9 1.1 1.2 1.8.3.6.4 1.3.5 2.4C22 8.9 22 9.3 22 12s0 3.1-.1 4.1c-.1 1.1-.2 1.8-.5 2.4-.3.7-.6 1.3-1.2 1.8-.5.6-1.1.9-1.8 1.2-.6.3-1.3.4-2.4.5-1 .1-1.4.1-4.1.1s-3.1 0-4.1-.1c-1.1-.1-1.8-.2-2.4-.5-.7-.3-1.3-.6-1.8-1.2-.6-.5-.9-1.1-1.2-1.8-.3-.6-.4-1.3-.5-2.4C2 15.1 2 14.7 2 12s0-3.1.1-4.1c.1-1.1.2-1.8.5-2.4.3-.7.6-1.3 1.2-1.8.5-.6 1.1-.9 1.8-1.2.6-.3 1.3-.4 2.4-.5C8.9 2 9.3 2 12 2zm0 5.4c-2.5 0-4.6 2-4.6 4.6s2 4.6 4.6 4.6 4.6-2 4.6-4.6-2.1-4.6-4.6-4.6zm0 7.6c-1.6 0-3-1.4-3-3s1.4-3 3-3 3 1.4 3 3-1.4 3-3 3zm5.8-7.8c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1z"/></svg>
        {compact ? "Instagram" : "@leilaonoradar"}
      </a>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-800/60 bg-slate-950/50" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row justify-between gap-6">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center">
                <Radar className="w-5 h-5 text-emerald-950" strokeWidth={2.5} />
              </div>
              <div className="font-display font-extrabold text-white text-lg">LeilãoRadar AI</div>
            </Link>
            <p className="mt-3 text-xs text-slate-500 max-w-sm">Inteligência para leilões judiciais de veículos no Brasil — cobertura das juntas comerciais, análise IA e comparativo FIPE.</p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400 font-mono mb-3">Entre pra comunidade</div>
            <SocialButtons />
            <p className="mt-3 text-xs text-slate-500 max-w-xs">Receba lotes exclusivos, análises e dicas de lance direto no seu WhatsApp e feed do Instagram.</p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-slate-800/60 text-center text-xs text-slate-500">
          © 2026 LeilãoRadar AI · Análises meramente informativas — consulte sempre o edital antes de dar lance.
        </div>
      </div>
    </footer>
  );
}
